import { ConcreteTest } from '../../../types'
import CIMSTable from 'components/CIMSTable'
import { HelpMessage } from 'utils/constants'
import { dateFormatter } from '../../../../../../../../../../../../../../utils/dateFormatter'

function FirstTable(record: ConcreteTest) {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Tests
  return (
    <CIMSTable
      records={[record]}
      rowKey="globalId"
      size="small"
      columns={[
        {
          title: 'Sampled At',
          help: help.SampledAt,
          width: 111,
          render: ({ sampleAtQuantity, truckNumber }) =>
            (sampleAtQuantity ?? 0) < 0
              ? `Truck ${truckNumber}`
              : sampleAtQuantity,
        },
        {
          title: 'Batch Time',
          help: help.BatchTime,
          width: 125,
          render: ({ batchTime }) => dateFormatter.shortDatetime(batchTime),
        },
        {
          title: 'Sampled Time',
          help: help.SampledTime,
          width: 128,
          render: ({ timeTested }) => dateFormatter.shortDatetime(timeTested),
        },
        {
          title: 'Sample Location',
          help: help.SampleLocation,
          width: 143,
          /**
           * future field
           */
          render: () => '',
        },
        {
          title: 'Alignment',
          help: help.Alignment,
          width: 101,
          /**
           * future field
           */
          render: () => '',
        },
        {
          title: 'IA Sample With',
          help: help.IASampleWith,
          width: 134,
          render: 'iaWith',
        },
        {
          title: 'Air Meter',
          help: help.AirMeter,
          width: 95,
          render: 'airMeterNumber',
        },
        {
          title: 'Calibration Date',
          help: help.CalibrationDate,
          width: 139,
          render: ({ airMeterCalibrationDate }) =>
            dateFormatter.simple(airMeterCalibrationDate),
        },
      ]}
    />
  )
}

export default FirstTable
